import Die_Metarec from "../assets/image/png/Die_Metarec.png";
import play_btn from "../assets/image/png/Play.png";
const UnderCardData = [
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
  {
    Img: Die_Metarec,
    play_btn: play_btn,
    par: "Under the direction of Managing Director Christian Schmitt, Metarec GmbH supports small and medium-sized companies in recruiting qualified specialists to eliminate the shortage of skilled workers ",
  },
];
export default UnderCardData;
